import { useEffect } from "react";
import { TTP_OFFFCOURSE_URL } from "../../../config";

const isOfffcourseOrigin = (origin) => {
  try {
    return origin === new URL(TTP_OFFFCOURSE_URL).origin;
  } catch (e) {
    return false;
  }
};

export default function useRedirectTopListener() {
  useEffect(() => {
    const handleMessage = (event) => {
      if (
        event.data?.event === "REDIRECT_TOP" &&
        event.data.message &&
        isOfffcourseOrigin(event.origin)
      ) {
        window.location.href = event.data.message;
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);
}
